import React from 'react'
import MaterialBox from '../../../../components/MaterialBox'
import MaterialTypography from '../../../../components/MaterialTypography'


const BasicDetails = () => {
    return (
        <MaterialBox sx={{ padding: 1, border: '1px solid #ccd2d9', borderRadius: 2 }}>
            <MaterialBox sx={{ display: 'flex', flexDirection: 'row', gap: 0.5, alignItems: 'center' }}>
                <MaterialBox sx={{ width: '6px', height: '12px', borderRadius: '30%', backgroundColor: '#5682e8' }} />
                <MaterialTypography variant='body2' fontWeight='bold' color='dark'>Basic Details</MaterialTypography>
            </MaterialBox>

            <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, alignItems: 'flex-start', mt: 1.5 }}>
                <MaterialTypography variant='caption' fontWeight='bold'>Project Manager</MaterialTypography>
                <MaterialTypography variant='caption'>John Doe</MaterialTypography>
            </MaterialBox>

            <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, alignItems: 'flex-start', mt: 1.5 }}>
                <MaterialTypography variant='caption' fontWeight='bold'>Status</MaterialTypography>
                <MaterialTypography variant='caption'>In Progress</MaterialTypography>
            </MaterialBox>

            <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, alignItems: 'flex-start', mt: 1.5 }}>
                <MaterialTypography variant='caption' fontWeight='bold'>Project Type</MaterialTypography>
                <MaterialTypography variant='caption'>Implementation & Customization</MaterialTypography>
            </MaterialBox>

            <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, alignItems: 'flex-start', mt: 1.5 }}>
                <MaterialTypography variant='caption' fontWeight='bold'>Budget</MaterialTypography>
                <MaterialTypography variant='caption'>$200,000</MaterialTypography>
            </MaterialBox>

            <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, alignItems: 'flex-start', mt: 1.5 }}>
                <MaterialTypography variant='caption' fontWeight='bold'>Start Date</MaterialTypography>
                <MaterialTypography variant='caption'>Feb 07 2026</MaterialTypography>
            </MaterialBox>

            <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, alignItems: 'flex-start', mt: 1.5 }}>
                <MaterialTypography variant='caption' fontWeight='bold'>End Date</MaterialTypography>
                <MaterialTypography variant='caption'>May 07 2026</MaterialTypography>
            </MaterialBox>


        </MaterialBox>
    )
}

export default BasicDetails